import { images } from "@/utils/data"
import classNames from "classnames"

interface ActionCardProps {
  card: IBonusCard
  className?: string
}

const ActionCard: React.FC<ActionCardProps> = ({ card, className }) => {
  return (
    <div className={`bg-[#fbe1a6] h-48 w-72 z-30 ${className}`}>
      <img
        className="w-full h-full object-contain bg-[#fbe1a6] "
        //@ts-ignore
        src={images.cards[card.id]}
        alt="Bonus Card Front"
      />
      {/* <div className="flex items-center justify-around flex-col h-full w-full border-black border relative">
        <div
          className={classNames(`
            "text-chest-back font-poppins font-medium absolute top-0 left-1/2 bg-white  -translate-y-1/2 -translate-x-1/2 text-[8px] px-1 ",
            { "text-chance-back": card.type === "chance" }
          )}
        >
          {card.type === "chance" ? "Action Card" : "Action Card"}
        </div>
        <p className="font-primary text-center text-lg text-black p-4">
          {card.text}
        </p>
        <div className="text-[8px] text-black font-poppins absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 bg-white px-1">
          Monopoly
        </div> */}
      {/* </div> */}
    </div>
  )
}

export default ActionCard
